/**
 * Attendance values for Event Participants / Participants Details filters.
 * Empty string = All. Includes Cancelled (historical rows; not in active unique index).
 */
export const EVENT_ATTENDANCE_FILTER_OPTIONS = [
  "",
  "Registered",
  "No-Show",
  "Attended",
  "Walk-In",
  "Waitlisted",
  "Cancelled",
];

/** Canonical EventParticipant.attendance key; empty → Registered. */
export function getEventAttendanceKey(attendanceRaw) {
  const key = (attendanceRaw != null ? String(attendanceRaw) : "").trim();
  return key || "Registered";
}

/**
 * Count participants by raw attendance key (server values).
 * @param {Record<string, unknown>[]} participants
 * @returns {Map<string, number>}
 */
export function countParticipantsByAttendance(participants) {
  const counts = new Map();
  for (const p of Array.isArray(participants) ? participants : []) {
    const key = getEventAttendanceKey(p?.attendance);
    counts.set(key, (counts.get(key) || 0) + 1);
  }
  return counts;
}

/**
 * Chip options for attendance quick filters: only statuses present, ordered like
 * EVENT_ATTENDANCE_FILTER_OPTIONS, then any unexpected keys.
 * @param {Record<string, unknown>[]} participants
 * @returns {{ value: string, count: number }[]}
 */
export function getAttendanceFilterChipOptions(participants) {
  const counts = countParticipantsByAttendance(participants);
  const ordered = [];
  const seen = new Set();
  for (const opt of EVENT_ATTENDANCE_FILTER_OPTIONS) {
    if (!opt) continue;
    const n = counts.get(opt) || 0;
    if (n <= 0) continue;
    ordered.push({ value: opt, count: n });
    seen.add(opt);
  }
  for (const [value, count] of counts.entries()) {
    if (seen.has(value) || count <= 0) continue;
    ordered.push({ value, count });
  }
  return ordered;
}

/**
 * @param {Record<string, unknown>[]} participants
 * @param {string|null|undefined} attendanceFilter raw attendance key, or null/"" for all
 */
export function filterParticipantsByAttendance(participants, attendanceFilter) {
  const list = Array.isArray(participants) ? participants : [];
  const want = attendanceFilter != null ? String(attendanceFilter).trim() : "";
  if (!want) return list;
  return list.filter((p) => getEventAttendanceKey(p?.attendance) === want);
}